export const padding = {
    pd15: 15,
    pd3: 3
  };
  